{
  "AddBuilders": "Agregar Builders",
  "NoBuilders": "No hay más builders para seleccionar",
  "cancel": "cancelar",
  "Builders": "Builders",
  "GroupMembers": "Miembros del grupo",
  "DueDate": "Fecha de vencimiento",
  "NoBuildersAdded": "Aún no se han agregado builders",
  "optional": " (Opcional)",
  "viewTemplates": "ver plantillas",
  "saveAsTemplate": "guardar como plantilla",
  "saveSchedule": "guardar programa",
  "SavedSuccessfully": "guardadas correctamente",
  "MissingDates": "Enter due_time for the missing dates",

  "GroupNameAlreadyTaken": "¡El nombre del grupo ya ha sido tomado!",
  "addedSuccessfully": " agregado exitosamente.",
  "Managers": "Propietarios ",
  "Members": "Miembros ",
  "GroupNameRequired": "El nombre del grupo es obligatorio",
  "CreateGroup": "Crear un grupo",
  "GroupName": "Nombre del Grupo ",
  "AddManagersToGroup": "AÑADIR ADMINISTRADORES AL GRUPO",
  "AddMembersToGroup": "AÑADIR MIEMBROS AL GRUPO",
  "NameOfGroup": "Nombre del Grupo *",
  "AddIntoGroup": "Agregar al Grupo",
  "Selected": "Seleccionado",
  "hub": "hub",
  "AllHub": "Todo Hub",
  "events": "Eventos",
  "groups": "Groupos",
  "AddProject": "+ Añadir proyecto",

  "CreateGroupPhrase1": "¿Quiere agregar a alguien que no sea parte de tu hub?",
  "InviteThem": "Invítalos.",
  "CreateGroupPhrase2": "Para agregar a alguien que no es parte de tu hub, debe ser un",
  "HubAdmin": "administrador de hub",
  "manager": "Propietario",
  "managers": "propietarios",
  "managedBy": "Gestionado por",
  "unassigned": "Sin asignar",
  "none": "ninguno",
  "empty": "vacío",
  "open": "Abrir",
  "group": "Grupo",
  "MoreInfo": "Más información.",
  "CreateGroupPhrase3part1": "Para agregar un administrador que no es parte de tu hub,",
  "CreateGroupPhrase3part2": "agrégalos al hub primero.",
  "CreateGroupPhrase3part3": "pídale a un administrador del hub que los agregue primero al hub.",
  "createGroup": "crea un grupo",
  "addManagers": "agregar administradores",
  "addMembers": "Añadir miembros",
  "InviteMembersTo": "Invitar miembros a",

  "deletedSuccessfully": "borrado exitosamente.",
  "EditGroup": "Editar grupo",
  "Manager": "Propietarios",
  "Member": "Miembros",
  "searchFor": "buscar",
  "removeSelected": "eliminar selección",
  "select": "Seleccionar",
  "ConfirmRemovingMember": "¿Está seguro de que desea eliminar a un miembro del grupo?",
  "RemovingMemberConsequence1": "Toda su información se eliminará, incluido su proyecto, si solo son miembros del equipo en este grupo",
  "RemovingMemberConsequence2": " No se eliminarán del hub",
  "Remove": "Eliminar",
  "member": " Miembro",

  "CreateBuilderSchedule": "Crear Programa del Builder",
  "ManageBuilderSchedule": "administrar Programa del Builder",
  "BuilderSchedule": "Programa del Builder",
  "setSchedule": "establecer programa",
  "seeAllBuilders": "ver todos los builders",
  "GroupBuilderPhrase1": "No has establecido un programa",
  "GroupBuilderPhrase2": "Controla que builders ven tus miembros aquí.",
  "GroupBuilderPhrase3": "Sin programa agregado",
  "Next": "Siguiente",
  "Upcoming": "Próximamente",
  "Past": "Anterior",

  "deactivate": "Desactivar",
  "delete": "Eliminar",
  "activate": "activar",
  "active": "activo",
  "inactive": "inactivo",
  "Projects": "Proyectos",
  "EmptyProjectDescription": "Sin descripción todavía...",
  "ConfirmGroupDeactivation": "¿Estás seguro de que quieres desactivar este grupo?",
  "GroupDeactivationConsequence": "Todas las habilidades para editar el grupo estarán deshabilitadas.",
  "ConfirmDeletingGroup": "¿Estás seguro de que deseas eliminar este grupo?",
  "DeletingGroupConsequence": "Esto eliminará el grupo para todos los miembros y administradores.",
  "InactiveSubscription": "Esta suscripción de Hub está inactiva",
  "InactiveSubscriptionMessage": "Tu acceso al hub será limitado. Si cree que esto es un error, comuníquese con ellos para renovar.",
  "ok": "Ok",
  "SubscriptionExpired": "¡Esta suscripción ha caducado!",
  "SubscriptionExpiredMessage": "Tu acceso al hub ahora es limitado. Por favor renueve poniéndose en contacto con nosotros.",
  "ContactUs": "Contacta con nosotros",
  "YouAre": "Eres el",

  "NoResultFound": "No se han encontrado resultados",
  "NoMembersYet": "Todavía no hay miembros aquí.",
  "NoProjectsAvailable": "No hay proyectos para mostrar aquí",

  "searchProjects": "proyectos de búsqueda",
  "seeMoreProjects": "ver más proyectos",
  "ProjectName": "Nombre del proyecto",
  "SearchProjectByName": "Buscar proyectos por nombre",

  "changeLogo": "cambiar logo",
  "EditMyRole": "Editar roles",
  "InviteMembers": "Invitar miembros",
  "hideHeader": "ocultar encabezado",
  "showHeader": "Mostrar Encabezado",
  "Activity": "Actividad",

  "manageTemplateHeader": "Tienes un programa sin guardar",
  "manageTemplateMessage": "Al abrir esta plantilla, se eliminará el programa no guardado. ¿Quieres seguir?",
  "Templates": "Plantillas",
  "YourCustomTemplates": "Tus plantillas personalizadas",
  "ChooseFromTemplates": "Elige entre plantillas",
  "confirm": "Confirmar",

  "viewBuilder": "Ver builder",
  "SingleProjectPhrase1": "Aún no hay builders programados",
  "Progress": "Progreso",
  "Overall": "En general",
  "switchProject": "cambiar proyecto",

  "TemplatesPhrase1": "Actualmente seleccionado: ",
  "No": "No",
  "TemplatesPhrase2": "Plantillas encontradas",
  "deleteTemplateButton": "eliminar plantilla",
  "buildScheduleButton": "construye tu propio programa",
  "openTemplateButton": "plantilla abierta",

  "searchForMember": "buscar miembro en",
  "selectAll": "seleccionar todo",
  "unselectAll": "deselecciona todo",

  "ExpandAll": "Expandir todo",
  "CollapseAll": "Desplegar todo",

  "UploadProject": "Subir proyecto",

  "Error": "¡Ups! Algo salió mal.",

  "HubGroupSinglePhrase1": "¿Cómo se realiza el seguimiento del progreso?",
  "Completed": "Completado:",
  "HubGroupSinglePhrase2": "Este builder está publicado en",
  "HubGroupsEvents": "Hub, grupos, eventos",
  "Everyone": "Cualquier persona",
  "HubGroupSinglePhrase3": "Nota: este icono seguirá apareciendo incluso si se omiten algunas respuestas.",
  "InProgress": "En progreso:",
  "HubGroupSinglePhrase4": "Se ha guardado una respuesta, pero el builder aún no se ha publicado en este grupo.",
  "NotStarted": "Sin empezar:",
  "HubGroupSinglePhrase5": "No se han guardado respuestas.",

  "NoDueDate": "Sin fecha de vencimiento",
  "Settings": "Configuración",
  "GroupStatus": "Estado del grupo",
  "GroupNameSectionDescription": "Este es el nombre que ven los miembros y administradores de este grupo.",
  "GroupStatusDescription": "Desactivar oculta este grupo a sus miembros y pausa su programa de builders."
}
